export const QUERY_KEY_LANG_PREV = 'langPrev'
export const QUERY_KEY_SLUG_TYPE = 'slugType'